import {
  useGeneralSurveyUpdateMutation,
  GeneralSurveyUpdateMutationOptions,
  useGeneralSurveyCreateMutation,
  GeneralSurveyCreateMutationOptions,
  GeneralSurveyStatusUpdateMutationOptions,
  useGeneralSurveyStatusUpdateMutation,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useGeneralSurveyCreate = (baseOptions?: GeneralSurveyCreateMutationOptions) =>
  useMutation(useGeneralSurveyCreateMutation, baseOptions);

export const useGeneralSurveyUpdate = (baseOptions?: GeneralSurveyUpdateMutationOptions) =>
  useMutation(useGeneralSurveyUpdateMutation, baseOptions);

export const useGeneralSurveyStatusUpdate = (
  baseOptions?: GeneralSurveyStatusUpdateMutationOptions,
) => useMutation(useGeneralSurveyStatusUpdateMutation, baseOptions);
